<template>
   <section>
      <v-container fluid>
         <!-- Header -->
         <ControlHeader :pageData="pageData" :form="form" :save="save" :valid="valid" :deleteMethod="deleteMethod" />
         <!-- End Of Header -->
         <!-- Form -->
         <v-form ref="form" v-model="valid" class="pa-5 px-0">
            <v-card class="backgroundW shadow pa-5 pt-7">
               <v-row align="center">
                  <GenericInput type="text" :value="form.name_ar" @input="form.name_ar = $event" label="الأسم بالعربي"
                     :required="true" :isLoading="pageData.editIsLoading" :cols="[12, 12, 6]">
                  </GenericInput>
                  <GenericInput type="text" :value="form.name_en" @input="form.name_en = $event" label="name in english"
                     :required="true" :isLoading="pageData.editIsLoading" :cols="[12, 12, 6]">
                  </GenericInput>

                  <GenericInput type="select" :lookups="governorates" :value="form.govs" @input="form.govs = $event"
                     label="select governorates" selected_label="name" selected_prop="id" :multi="true" :required="true"
                     :isLoading="pageData.editIsLoading" :cols="[12, 12, 6]">
                  </GenericInput>

                  <GenericInput type="select" :lookups="products" :value="form.product_id"
                     @input="form.product_id = $event" label="product" selected_label="name" selected_prop="id"
                     :multi="false" :required="true" :isLoading="pageData.editIsLoading" :cols="[12, 12, 6]" />

                  <GenericInput type="select" :disabled="!(form.product_id)" :lookups="filtered_products_types"
                     :value="form.product_type_id" @input="form.product_type_id = $event"
                     :label="!form.product_id ? 'product type (select product first)' : 'product type'"
                     selected_label="name" selected_prop="id" :multi="false" :required="true"
                     :isLoading="pageData.editIsLoading" :cols="[12, 12, 6]" />
                  <GenericInput type="select" :lookups="producers" :value="form.producer_id"
                     @input="form.producer_id = $event" label="producer" selected_label="name" selected_prop="id"
                     :multi="false" :required="true" :isLoading="pageData.editIsLoading" :cols="[12, 12, 6]">
                  </GenericInput>
                  <GenericInput type="textarea" :value="form.description_ar" @input="form.description_ar = $event"
                     label="الوصف بالعربي" :required="false" :isLoading="pageData.editIsLoading" :cols="[12, 6, 6]">
                  </GenericInput>
                  <GenericInput type="textarea" :value="form.description_en" @input="form.description_en = $event"
                     label="description in english" :required="false" :isLoading="pageData.editIsLoading"
                     :cols="[12, 6, 6]">
                  </GenericInput>
                  <GenericInput type="file" :value="form.photo_ar" @input="form.photo_ar = $event" :cols="[12, 6, 6]"
                     label="صوره المنتج بالعربي" :multi="false" :required="false" :isLoading="pageData.editIsLoading">
                  </GenericInput>
                  <GenericInput type="file" :value="form.photo_en" @input="form.photo_en = $event" :cols="[12, 6, 6]"
                     label="english item image" :multi="false" :required="false" :isLoading="pageData.editIsLoading">
                  </GenericInput>
               </v-row>
            </v-card>
         </v-form>
         <!-- End of Form -->
      </v-container>
   </section>
</template>



<script>
import GenericInput from '@/components/ui/GenericInput.vue';
import ControlHeader from "@/components/ui/ControlHeader.vue";
export default {
   name: "ItemsControl",
   data: () => ({
      pageData: {
         screen_code: "05-005",
         url: null,
         controlRoute: "prices/item-control",
         entityName: null,
         main: null,
         category: null,
         isLoading: true,
         isEdit: false,
         editIsLoading: false,
      },
      valid: false,
      producers: [],
      governorates: [],
      products: [],
      products_types: [],
      form: {
         product_id: null,
         product_type_id: null,
         producer_id: null,
         name_ar: null,
         name_en: null,
         description_en: null,
         description_ar: null,
         govs: null,
         photo_en: null,
         photo_ar: null,
      }
   }),
   components: {
      ControlHeader,
      GenericInput,
   },
   computed: {
      filtered_products_types() {
         return this.products_types.filter((type) => type['product_id'] == this.form.product_id)
      },
   },
   watch: {
      "form.product_id"() {
         if (this.pageData.isEdit == false) {
            this.form.product_type_id = null;
         }
      },
   },
   mounted() {
      this.pageMainData();
      this.formatDate();
      this.getData();
   },
   methods: {
      pageMainData() {
         this.pageData.main = this.$global.FilterPermissions(this.pageData.screen_code).main_title;
         this.pageData.category = this.$global.FilterPermissions(this.pageData.screen_code).cat_title;
         this.pageData.url = this.$global.FilterPermissions(this.pageData.screen_code).url;
         this.pageData.entityName = this.pageData.entityName = this.$route.params.id ? this.$i18n.t("edit") + " " + this.$global.FilterPermissions(this.pageData.screen_code).sub_title : this.$i18n.t("add") + " " + this.$global.FilterPermissions(this.pageData.screen_code).sub_title;
      },
      getData() {
         if (this.$route.params.id) {
            if (this.$global.CheckAction(this.pageData.screen_code, 3)) {
               this.pageData.isEdit = true;
               this.pageData.editIsLoading = true;
               this.pageData.isLoading = true;
               this.$api.GET_METHOD(`item/${this.$route.params.id}`).then((response) => {
                  this.pageData.editIsLoading = false;
                  this.pageData.isLoading = false;
                  if (response.check) {
                     console.log("response", response);
                     this.form = response.data.data;
                     this.products_types = response.data.products_types;
                     this.products = response.data.products;
                     this.governorates = response.data.governorates;
                     this.producers = response.data.producers;
                     this.form.govs = this.form.govs.split(',').map(i => Number(i));
                     this.$refs.form.validate();
                  }
               })
            } else {
               this.$router.push('/')
            }
         }
         else {
            if (this.$global.CheckAction(this.pageData.screen_code, 2)) {

               this.pageData.isLoading = true;
               this.$api.GET_METHOD(`item/create`).then((response) => {
                  this.pageData.isLoading = false;
                  if (response.check) {
                     this.products_types = response.data.products_types;
                     this.products = response.data.products;
                     this.governorates = response.data.governorates;
                     this.producers = response.data.producers;
                  }
               })
            } else {
               this.$router.push('/')
            }

         }

      },
      save() {
         if (this.$refs.form.validate()) {
            this.pageData.isLoading = true;
            if (this.pageData.isEdit == true) {
               this.form._method = 'PUT';
               this.$api.POST_METHOD(`item/${this.form.id}`, this.form).then((response) => {
                  this.pageData.isLoading = false;
                  if (response.check) {
                     this.$router.push(this.pageData.url)
                  }
               })
            }
            else {
               this.$api.POST_METHOD(`item`, this.form).then((response) => {
                  this.pageData.isLoading = false;
                  if (response.check) {
                     this.$router.push(this.pageData.url)
                  }
               })
            }
         }
      },
      formatDate() {
         var d = new Date(),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

         if (month.length < 2)
            month = '0' + month;
         if (day.length < 2)
            day = '0' + day;
         this.form.item_date = [year, month, day].join('-');
      },
      deleteMethod(status) {
         if (status == true) {
            this.pageData.isLoading = true
            this.$api.POST_METHOD(`item/${this.form.item_id}`, { _method: 'delete' }).then(() => {
               this.$router.push(this.pageData.url);
               this.pageData.isLoading = false
            })
         }
      },


   },
};
</script>
